<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
#app {
  height: 100vh;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue